<template>
	<div class="component-image" :mask="mask">
		<picture>
			<source
				v-if="image.fields.file"
				type="image/avif"
				:width="width"
				:height="height"
				:alt="image.fields.title"
				loading="lazy"
				decoding="async"
				:srcset="`
				${image.fields.file.url}?w=${1600}&fm=avif 1x,
				${image.fields.file.url}?w=${1000}&fm=avif 2x,
				${image.fields.file.url}?&fm=avif 3x`"
			/>

			<source
				v-if="image.fields.file"
				type="image/webp"
				:width="width"
				:height="height"
				:alt="image.fields.title"
				loading="lazy"
				decoding="async"
				:srcset="`
				${image.fields.file.url}?w=${1600}&fm=webp 1x,
				${image.fields.file.url}?w=${1000}&fm=webp 2x,
				${image.fields.file.url}?&fm=webp 3x`"
			/>

			<img
				v-if="image.fields.file"
				:src="image.fields.file.url"
				:width="width"
				:height="height"
				:alt="image.fields.title"
				fetchpriority="high"
				decoding="async"
				:srcset="`
				${image.fields.file.url}?w=${1600}&fm=jpg&q=70&fl=progressive 1x,
				${image.fields.file.url}?w=${1000}&fm=jpg&q=70&fl=progressive 2x,
				${image.fields.file.url}?&fm=jpg&q=70&fl=progressive 3x`"
			>
		</picture>

<!--		<img-->
<!--			:src="image.fields.file.url"-->
<!--			:width="width"-->
<!--			:height="height"-->
<!--			:alt="image.fields.title"-->
<!--			loading="lazy"-->
<!--			decoding="async"-->
<!--			:srcset="`-->
<!--			${image.fields.file.url}?w=${1600}&fm=jpg&q=70&fl=progressive 1x,-->
<!--			${image.fields.file.url}?w=${1000}&fm=jpg&q=70&fl=progressive 2x,-->
<!--			${image.fields.file.url}?&fm=jpg&q=70&fl=progressive 3x`"-->
<!--		>-->
	</div>
</template>

<script setup>
const props = defineProps({
	mask: {
		type: String
	},
	image: {
		type: Object,
		required: true
	}
});

const width = computed(() => {
	return Math.round(props.image.fields.file.details.image.width / 1.5);
});

const height = computed(() => {
	return Math.round(props.image.fields.file.details.image.height / 1.5);
});
</script>